<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

import simplebar from "simplebar-vue";
import API from "@/router/layouts/API";
import CopyableText from "@/components/CopyableText";

export default {
  page: {
    title: "GameLabs",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    /* eslint-disable vue/no-unused-components */
    simplebar,
    API,
    CopyableText
  },
  data() {
    return {

    };
  },
  validations: {

  },
  methods: {
    goto(refName) {
      let element = this.$refs[refName];
      element.scrollIntoView({ block: 'end', behavior: 'smooth' });
      this.$nextTick(() => {
        //document.scrollingElement.scrollTop -= 1;
      });
    },
  }
};
</script>

<template>
  <API>
    <!-- LINKS -->
    <template v-slot:contents>
      <ul class="c-menu">
        <li>
          <a
              class="font-size-16"
              href="javascript:void(0);"
              v-on:click="goto('introduction')"
          >
            Introduction
          </a>
        </li>
        <li>
          <a
              class="font-size-16"
              href="javascript:void(0);"
              v-on:click="goto('dayz')"
          >
            DayZ
          </a>
        </li>

      </ul>
    </template >
    <!-- CONTENT -->
    <template v-slot:content>
      <!-- Introduction -->
      <div class="c-api-section" ref="introduction">
        <h1 class="pb-0">
          Introduction
        </h1>
        <hr>
        <div class="c-api-content">
          CFTools Cloud keeps track of many things. Some of which you can also access.

          <b>Rights of the respective copyright holders apply.</b>
        </div>
      </div>
      <!-- Server Id -->
      <div class="c-api-section" ref="dayz">
        <h1 class="pb-0">
          DayZ
        </h1>
        <hr>
        <div class="c-api-content">
          <div class="c-api-spacer"/>
          <h3>
            Satellite images
          </h3>
          <table class="table table-bordered">
            <thead>
            <th>Map</th>
            <th>Resolution</th>
            <th>Link</th>
            </thead>
            <tbody>
            <tr>
              <td>
                Chernarus
              </td>
              <td>
                4096x4096
              </td>
              <td>
                <a
                    target="_blank"
                    href="https://cdn.cftools.de/static_assets/game_labs/maps/game_dayz_chernarus.png"
                >
                  https://cdn.cftools.de/static_assets/game_labs/maps/game_dayz_chernarus.png
                </a>
              </td>
            </tr>
            <tr>
              <td>
                Livonia (Enoch)
              </td>
              <td>
                4096x4096
              </td>
              <td>
                <a
                    target="_blank"
                    href="https://cdn.cftools.de/static_assets/game_labs/maps/game_dayz_enoch.png"
                >
                  https://cdn.cftools.de/static_assets/game_labs/maps/game_dayz_enoch.png
                </a>
              </td>
            </tr>
            <tr>
              <td>
                Deerisle
              </td>
              <td>
                4096x4096
              </td>
              <td>
                <a
                    target="_blank"
                    href="https://cdn.cftools.de/static_assets/game_labs/maps/game_dayz_deerisle.png "
                >
                  https://cdn.cftools.de/static_assets/game_labs/maps/game_dayz_deerisle.png
                </a>
              </td>
            </tr>
            <tr>
              <td>
                Chiemsee
              </td>
              <td>
                4096x4096
              </td>
              <td>
                <a
                    target="_blank"
                    href="https://cdn.cftools.de/static_assets/game_labs/maps/game_dayz_chiemsee.png"
                >
                  https://cdn.cftools.de/static_assets/game_labs/maps/game_dayz_chiemsee.png
                </a>
              </td>
            </tr>
            <tr>
              <td>
                Esseker
              </td>
              <td>
                4096x4096
              </td>
              <td>
                <a
                    target="_blank"
                    href="https://cdn.cftools.de/static_assets/game_labs/maps/game_dayz_esseker.png"
                >
                  https://cdn.cftools.de/static_assets/game_labs/maps/game_dayz_esseker.png
                </a>
              </td>
            </tr>
            <tr>
              <td>
                Valning
              </td>
              <td>
                4096x4096
              </td>
              <td>
                <a
                    target="_blank"
                    href="https://cdn.cftools.de/static_assets/game_labs/maps/game_dayz_valning.png "
                >
                  https://cdn.cftools.de/static_assets/game_labs/maps/game_dayz_valning.png
                </a>
              </td>
            </tr>
            <tr>
              <td>
                Rostow
              </td>
              <td>
                4096x4096
              </td>
              <td>
                <a
                    target="_blank"
                    href="https://cdn.cftools.de/static_assets/game_labs/maps/game_dayz_rostow.png"
                >
                  https://cdn.cftools.de/static_assets/game_labs/maps/game_dayz_rostow.png
                </a>
              </td>
            </tr>
            <tr>
              <td>
                Namalsk
              </td>
              <td>
                4096x4096
              </td>
              <td>
                <a
                    target="_blank"
                    href="https://cdn.cftools.de/static_assets/game_labs/maps/game_dayz_namalsk.png"
                >
                  https://cdn.cftools.de/static_assets/game_labs/maps/game_dayz_namalsk.png
                </a>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </template>
  </API>
</template>